// src/components/Banner/Banner.jsx
import { Link } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import { RiFolderInfoFill } from "react-icons/ri";
import { motion } from "framer-motion";
import "../../../pages/shared/Shared.css";
import { SecondaryBtn } from "../../../components";
import profilePic from "../../../assets/simraaa.png";

const Banner = () => {
  return (
    <div className="relative overflow-hidden bg-[#0c0a16] w-full py-16 sm:py-20">

      {/* Background static blobs — subtle ambient glow */}
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="absolute top-0 right-0 w-72 h-72 bg-violet-700/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-800/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16
                      flex flex-col-reverse lg:flex-row items-center justify-between gap-10 lg:gap-8">

        {/* LEFT — Text content */}
        <motion.div
          initial={{ x: -60, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="text-center lg:text-left w-full lg:w-1/2 max-w-xl mx-auto lg:mx-0"
        >
          <p className="text-violet-300 text-base sm:text-lg font-medium mb-1 tracking-wide">
            Hello, I'm
          </p>

          <h2 className="text-2xl sm:text-3xl font-bold mb-3 bg-gradient-to-r from-violet-400 to-indigo-400 bg-clip-text text-transparent">
            Simra Malik
          </h2>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black mb-4 text-white leading-tight">
            I Build <span className="bg-gradient-to-r from-violet-400 to-indigo-400 bg-clip-text text-transparent">Web & Apps</span> That Make Money
          </h1>

          <p className="text-lg sm:text-xl text-violet-200 font-semibold mb-4">
            Full Stack Developer
          </p>

          <p className="text-sm sm:text-base text-violet-100/80 max-w-lg mx-auto lg:mx-0 mb-7 leading-relaxed">
            A passionate Full-Stack Developer blending frontend creativity with backend logic
            to build seamless, high-performance applications using modern technologies.
          </p>

          <div className="flex items-center justify-center lg:justify-start flex-wrap gap-3">
            <a href="/Simra's_Malik.pdf" target="_blank" rel="noopener noreferrer">
              <button className="flex items-center gap-2 bg-gradient-to-r from-violet-600 to-indigo-500
                                 hover:from-violet-700 hover:to-indigo-600 text-white font-medium
                                 transition-all duration-300 rounded-xl px-6 py-3 shadow-lg
                                 hover:shadow-violet-500/30 whitespace-nowrap text-sm sm:text-base">
                <span>Hire Me</span>
                <FaDownload className="text-xs" />
              </button>
            </a>
            <Link to="/about">
              <SecondaryBtn>
                <span>About Me</span>
                <RiFolderInfoFill />
              </SecondaryBtn>
            </Link>
          </div>
        </motion.div>

        {/* RIGHT — Profile image */}
        <motion.div
          initial={{ x: 60, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="w-full lg:w-1/2 flex justify-center items-center"
        >
          <div className="relative inline-flex justify-center items-center">

            <div className="absolute w-72 h-72 sm:w-80 sm:h-80 md:w-96 md:h-96 lg:w-[440px] lg:h-[440px]
                            bg-gradient-to-br from-violet-600/20 via-indigo-600/12 to-transparent
                            rounded-full blur-3xl z-0" />

            {/* Decorative shapes — desktop only */}
            <motion.div
              className="hidden lg:block absolute w-32 h-32 border border-violet-400/20 rounded-full -top-4 -right-4 z-10"
              animate={{ y: [0, -16, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
              style={{ willChange: "transform" }}
            />
            <motion.div
              className="hidden lg:block absolute w-16 h-16 border border-indigo-400/20
                          rounded-xl -bottom-4 -left-4 z-10 rotate-45"
              animate={{ y: [0, 12, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
              style={{ willChange: "transform" }}
            />

            <motion.div
              className="relative z-20"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 250 }}
            >
              <div className="p-1 rounded-full bg-gradient-to-br from-violet-500/80 to-indigo-500/80">
                <img
                  src={profilePic}
                  alt="Simra Malik"
                  className="rounded-full w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-96 lg:h-96 xl:w-[420px] xl:h-[420px] object-cover object-[50%_20%] shadow-2xl"
                />
              </div>
            </motion.div>

          </div>
        </motion.div>

      </div>
    </div>
  );
};

export default Banner;
